export const EmptyAlert = ({
  title = 'Nenhum registro encontrado',
  description = 'Nao ha dados para exibir no momento.'
}) => (
  <div className="alert alert-warning text-center mb-0">
    <div className="font-semibold">{title}</div>
    <div className="text-gray-700 text-sm">{description}</div>
  </div>
)
